angular
  .module('subscriptionProductAdd')
  .component('subscriptionProductAdd', {
    template: require('./subscription-product-add.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', 'AuthService', 'envService', 'Upload',
      function SubscriptionProductViewController($rootScope, $scope, $resource, $route, $location, $window, $translate, AuthService, envService, Upload) {
        $rootScope.mainmenu = 'service';
        $rootScope.menu = 'subscriptionProduct';
        const API_URL = envService.read('apiUrl'); // eslint-disable-line
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }
        this.group = { repeat_1_enabled: true, repeat_2_enabled: false, repeat_4_enable: false, DURATION_MIN: '0', DURATION_MAX: '10', NAME: 'abcd', DESCRIPTION: 'defg', medias: [''] };
        this.repeat_1 = {};
        this.repeat_2 = {};
        this.repeat_4 = {};

        function initialze(ctrl) {
          const PRODUCTS = [];
          ctrl.meta.carTypes.forEach((carType) => {
            PRODUCTS.push({ PRICE: 1000, PRODUCT_PRICE: 1000, GROUP_GOODS_ID: carType.ITEMCD, ITEMCD: carType.ITEMCD, ITEMNM: carType.ITEMNM, GOODS: [] });
          });
          ctrl.repeat_1.PRODUCTS = jQuery.extend(true, [], PRODUCTS);
          ctrl.repeat_1.REPEAT_TYPE = 1;
          ctrl.repeat_1.GOODS = [{}];
          ctrl.repeat_2.PRODUCTS = jQuery.extend(true, [], PRODUCTS);
          ctrl.repeat_2.REPEAT_TYPE = 2;
          ctrl.repeat_2.GOODS = [{}, {}];
          ctrl.repeat_4.PRODUCTS = jQuery.extend(true, [], PRODUCTS);
          ctrl.repeat_4.REPEAT_TYPE = 4;
          ctrl.repeat_4.GOODS = [{}, {}, {}, {}];
        }

        $resource(`${API_URL}/admin/meta/subscription/add `).get().$promise
          .then((data) => {
            this.meta = data;
            initialze(this);
          })
          .catch((err) => {
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        this.typeChanged = (good) => {
          good.OPTIONS = jQuery.extend(true, [], this.meta.options.filter(option => parseInt(option.GROUP_GOODS_ID, 10) === 1 && option && option.TYPE === good.TYPE));
        };
        this.submit = () => {
          if (!this.group.NAME || this.group.NAME.length < 1) {
            alert($translate.instant('상품명을 입력해주세요.'));
            return;
          }
          if (!this.group.NAME_EN || this.group.NAME_EN.length < 1) {
            alert($translate.instant('상품명을 입력해주세요.'));
            return;
          }
          if (!this.group.DESCRIPTION || this.group.DESCRIPTION.length < 1) {
            alert($translate.instant('상품 설명을 입력해주세요.'));
            return;
          }
          if (!this.group.DESCRIPTION_EN || this.group.DESCRIPTION_EN.length < 1) {
            alert($translate.instant('영문 설명을 입력해주세요.'));
            return;
          }
          if (!this.group.DETAIL_DESCRIPTION || this.group.DETAIL_DESCRIPTION.length < 1) {
            alert($translate.instant('설명을 작성해주세요.'));
            return;
          }
          if (!this.group.DETAIL_DESCRIPTION_EN || this.group.DETAIL_DESCRIPTION_EN.length < 1) {
            alert($translate.instant('상세영문 설명을 입력해주세요.'));
            return;
          }
          if (!this.group.repeat_1_enabled && !this.group.repeat_2_enabled && !this.group.repeat_4_enabled) {
            alert($translate.instant('최소 한개 이상의 세차 제공 회차를 선태해주세요.'));
            return;
          }
          const transformProducts = (payload) => {
            const products = [];
            for (let idxProducts = 0; idxProducts < payload.PRODUCTS.length; idxProducts += 1) {
              const product = jQuery.extend(true, {}, payload.PRODUCTS[idxProducts]);
              product.REPEAT_TYPE = payload.REPEAT_TYPE;
              products.push(product);

              for (let idx = 0; idx < payload.GOODS.length; idx += 1) {
                const good = payload.GOODS[idx];
                product.GOODS.push(...jQuery.extend(true, [], this.meta.goods[good.TYPE].filter(metaGood => metaGood.GROUP_GOODS_ID === parseInt(product.ITEMCD, 10))
                  .map((goodItem) => { goodItem.PAYLOAD_OPTIONS = good.OPTIONS; return goodItem; })));
              }

              product.GOODS = product.GOODS.map((mapGood) => {
                if (!mapGood.OPTIONS) {
                  mapGood.OPTIONS = [];
                }
                for (let idxOptions = 0; idxOptions < mapGood.PAYLOAD_OPTIONS.length; idxOptions += 1) {
                  const option = mapGood.PAYLOAD_OPTIONS[idxOptions];
                  if (option.enabled) {
                    mapGood.OPTIONS.push(...this.meta.options.filter(metaOption => metaOption.TB_GOODS_ID === mapGood.ID && metaOption.OPTION_NAME === option.OPTION_NAME));
                  }
                }
                return mapGood;
              });
            }
            this.group.PRODUCTS.push(...products);
          };
          this.group.PRODUCTS = [];
          try {
            if (this.group.repeat_1_enabled) {
              transformProducts(this.repeat_1);
            }
            if (this.group.repeat_2_enabled) {
              transformProducts(this.repeat_2);
            }
            if (this.group.repeat_4_enabled) {
              transformProducts(this.repeat_4);
            }
          } catch (e) {
            console.log(e);
            alert($translate.instant('상품을 선택해주세요.'));
            return;
          }
          this.group.MEDIAS = this.group.medias.filter(media => media.length > 0);
          $resource(`${API_URL}/admin/subscription/products`).save(this.group).$promise
            .then(() => {
              $location.path('/subscription/product');
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };


        this.addImage = () => {
          this.group.medias.push('');
        };

        this.uploadImage = (media, files, index) => {
          if (files && files.length) {
            const file = files[0];
            Upload.upload({
              url: `${API_URL}/admin/file/options`,
              file,
            }).progress(() => {
            }).success((data, status, headers, config) => { // eslint-disable-line no-unused-vars
              media = data.url;
              this.group.medias[index] = data.url;
              alert(this.group.medias);
            });
          }
        };

        this.removeImage = function removeImage(url, index) { // eslint-disable-line no-unused-vars
          const URLS = [];
          if (this.group.medias) {
            this.group.medias.forEach((item) => {
              if (item !== url) {
                URLS.push(item);
              }
            });
          }
          this.group.medias = URLS;
        };
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/subscription-product-add/subscription-product-add.component.js